module.exports = __webpack_public_path__ + "static/untitled-sans-web-regular-italic-408cbeb3714064bcc1bd6ca2e428a7ec.woff2";